var GeoData = /** @class */ (function () {
    function GeoData() {
        this.type = '';
    }
    return GeoData;
}());
export { GeoData };
var GeoPoint = /** @class */ (function () {
    function GeoPoint() {
    }
    return GeoPoint;
}());
export { GeoPoint };
var InsideMapPoint = /** @class */ (function () {
    function InsideMapPoint() {
    }
    return InsideMapPoint;
}());
export { InsideMapPoint };
var GeoPointInside = /** @class */ (function () {
    function GeoPointInside() {
        this.inside = false;
    }
    return GeoPointInside;
}());
export { GeoPointInside };
//# sourceMappingURL=GeoData.js.map